import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import { Studio } from '@src/types.ts/general';
import { useNavigate, useSearchParams } from 'react-router-dom';

import type { AssociatedVideo, VideoClip } from '@src/types.ts/story';

type ReturnValue = (video: VideoClip | AssociatedVideo) => void;

export function useNavigateToCreatorStudio(): ReturnValue {
  const videoCreator = useVideoCreatorStore();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleNavigate: ReturnValue = video => {
    searchParams.set('videoId', video.id!);

    videoCreator.prepareCreatorStudioNavigation();

    navigate({
      pathname: `/${Studio.creator}`,
      search: searchParams.toString(),
    });
  };

  return handleNavigate;
}
